function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M31 69.5C31 71.2 32.3 72.5 34 72.5 35.7 72.5 37 71.2 37 69.5L37 61.5 31 61.5 31 69.5Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.4 56.5 87 56.5C87 52.1 83.4 48.5 79 48.5L75.5 48.5C74.4 44.3 72.7 40.4 70.5 36.7 68.1 31.6 63.1 28.1 57.5 27.6 57 27.5 56.5 27.5 56 27.5 55.4 27.5 54.8 27.5 54.3 27.6L54 27.5 29 27.5 28.9 27.6C25.3 27.8 21.9 29.3 19.3 31.7 18.9 31.8 18.6 32.1 18.4 32.4 17.6 33.5 16 33.9 14.8 33.3 13.5 32.7 12.8 31.3 13.1 29.9 13.4 28.5 14.6 27.5 16 27.5 17.1 27.5 18 26.6 18 25.5 18 24.4 17.1 23.5 16 23.5 12.3 23.5 9.3 26.4 9 30.1 8.7 33.8 11.5 37 15.2 37.5 12.2 44.9 15.1 53.4 22 57.4L22 69.6C22 71.3 23.3 72.6 25 72.6 26.7 72.6 28 71.3 28 69.6L28 59.6 47 59.6 47 69.6C47 71.3 48.3 72.6 50 72.6 51.7 72.6 53 71.3 53 69.6L53 59.6 56 59.6 56 69.6C56 71.3 57.3 72.6 59 72.6 60.7 72.6 62 71.3 62 69.6L62 62 74.1 69.4C75.9 70.5 78.1 70.8 80.2 70.3 82.3 69.8 84 68.5 85.1 66.7L86 65.2 82.9 63.3 80.4 56.5Z",
  fill: "currentColor"
}));

var SvgPig = function SvgPig(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    id: "Icons_Pig",
    overflow: "hidden",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPig, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pig.496186db.svg";
export { ForwardRef as ReactComponent };